"use client";

import { usePathname } from "next/navigation";
const WHITE_LABEL_PREFIXES = ["/property/"];
const isWhiteLabelRoute = (pathname: string | null) => WHITE_LABEL_PREFIXES.some(prefix => pathname?.startsWith(prefix));
export const HideOnWhiteLabel = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const pathname = usePathname();
  if (isWhiteLabelRoute(pathname)) return null;
  return <>{children}</>;
};